export const primaryButtonStyle = (pressed, id, hover) => ({
  height: 40,
  minWidth: 64,
  padding: '0 24px',
  borderRadius: 20,
  border: 'none',
  background: hover ? '#06857a' : '#1e3f44',
  color: '#E7DFEC',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow:
    pressed === id
      ? 'inset 0 3px 8px rgba(0,0,0,0.3)'
      : '0 6px 10px rgba(0,0,0,0.7)',
  transform: pressed === id ? 'scale(0.96)' : 'scale(1)',
  transition: 'transform 0.08s ease, box-shadow 0.08s ease'
})

export const alternativeButtonStyle = (pressed, id, hover) => ({
  height: 40,
  minWidth: 64,
  padding: '0 24px',
  borderRadius: 20,
  border: 'none',
  background: hover ? '#c8c9c9' : '#E7DFEC',
  color: '#1e3f44',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow:
    pressed === id
      ? 'inset 0 3px 8px rgba(0,0,0,0.25)'
      : '0 6px 10px rgba(0,0,0,0.35)',
  transform: pressed === id ? 'scale(0.96)' : 'scale(1)',
  transition: 'transform 0.08s ease, box-shadow 0.08s ease'
})

export const modalPrimaryButtonStyle = (pressed, id, hover) => ({
  height: 40,
  minWidth: 64,
  padding: '0 24px',
  borderRadius: 20,
  border: 'none',
  background: hover ? '#06857a' : '#1e3f44',
  color: '#E7DFEC',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
boxShadow:
  pressed === id
    ? 'inset 0 2px 6px rgba(0,0,0,0.28)'
    : '0 4px 8px rgba(0,0,0,0.45)',
  transform: pressed === id ? 'scale(0.96)' : 'scale(1)',
  transition: 'transform 0.08s ease, box-shadow 0.08s ease'
})

export const modalSecondaryButtonStyle = (pressed, id, hover) => ({
  height: 40,
  minWidth: 64,
  padding: '0 24px',
  borderRadius: 20,
border: '1.5px solid #1e3f44',
background: hover ? 'rgba(30,63,68,0.08)' : 'transparent',
color: '#1e3f44',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow:
    pressed === id
      ? 'inset 0 2px 4px rgba(0,0,0,0.35)'
      : '0 3px 8px rgba(0,0,0,0.25)',
  transform: pressed === id ? 'translateY(1px)' : 'translateY(0)',
  transition: 'transform 0.08s ease, box-shadow 0.08s ease'
})